import React from 'react';
import { 
    Grid,
    Container,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    CircularProgress,
    Table,
    TableCell,
    TableContainer,
    TableRow,
    Button
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Image from '../image';
import Assets from '../../assets';
import SignInContainer from '../../components/signin/container';
import useFetch from '../../services/useFetch';
import { UserContext } from '../../app';
import './style.css';

function AccountDetails() {
    const { currentUser } = React.useContext(UserContext);
    const [userDetails, setUserDetails] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [isCopied, setIsCopied] = React.useState(false);

    const handleCopyKey = () => {
        navigator.clipboard.writeText(userDetails.domainAPIKey);
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1000);
    };

    const {
        call: getUserDetailsAPICall,
        data: getUserDetailsAPIData,
        error: getUserDetailsAPIError,
    } = useFetch(
        '/V5.0/DeveloperPortal/GetUserDetails',
        'POST',
        {},
        {},
        {
            userId: currentUser?.userId,
        },
        [],
        { callOnMount: false }
    );
  
    React.useEffect(() => {
        if (currentUser) {
            getUserDetailsAPICall();
        }
    }, []);

    React.useEffect(() => {
        setLoading(false);
        if (getUserDetailsAPIData?.firstName && getUserDetailsAPIData?.lastName) {
            setUserDetails(getUserDetailsAPIData);
        }
    }, [getUserDetailsAPIData]);

    const getCapitalizedText = (text) => {
        if (text?.length) return text[0] + text.substring(1).toLowerCase();

        return text;
    };

    const getAPIKeyToDisplay = (text) => {
        if (text) {
            let str = '';
            for (let i=0; i < text.length; i++) {
                if (i < 24) {
                    str = str + '*';
                } else {
                    str = str + text[i];
                }
            }
            return str;
        }
        return text;
    };
    
    return (
        <Grid container className="sign">
            <Grid item sm={12} md={12} lg={12}>
                <SignInContainer>
                    <Container maxWidth="md" className="profile-form">
                        <Grid container>
                            <Grid item sm={12} md={12} lg={12} className="img-container">
                                <Image
                                    src={Assets.Images.AccountDetails.Path}
                                    alt={Assets.Images.AccountDetails.Alt}
                                    className="signin-img"
                                />
                            </Grid>
                            <Grid item sm={12} md={12} lg={12} className="title-container">
                                <Typography className="title">Profile</Typography>
                                <div className="border" />
                            </Grid>
                            {(loading || !userDetails) ? (
                                <div className="loader">
                                    <CircularProgress color="primary" size={40} />
                                </div>
                            ) : (
                            <Grid item sm={12} md={12} lg={12} className="title-container">
                                <div className='accordset'>
                                    <Accordion className="accordion-box" defaultExpanded>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel-AccountDetails">
                                            <Typography>Account Details</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <TableContainer >
                                                <Table className="accordion-table-cell">                
                                                    <TableRow>
                                                        <TableCell>First Name</TableCell>
                                                        <TableCell>{getCapitalizedText(userDetails.firstName)}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Last Name</TableCell>
                                                        <TableCell>{getCapitalizedText(userDetails.lastName)}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Email Address</TableCell>
                                                        <TableCell>{userDetails.email}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>User Groups</TableCell>
                                                        <TableCell data-title={userDetails.userGroups}><div className='maxLength'>{userDetails.userGroups}</div></TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Office Location</TableCell>
                                                        <TableCell>{userDetails.officeLocation}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>Firm ID</TableCell>
                                                        <TableCell>{userDetails.domainName}</TableCell>
                                                    </TableRow>  
                                                </Table>
                                            </TableContainer>
                                        </AccordionDetails>
                                    </Accordion>

                                {userDetails.domainAPIKey ? (
                                    <Accordion className="accordion-box" defaultExpanded>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel-ApiKey">
                                            <Typography>API Details</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <TableContainer>
                                                <Table>
                                                    <TableRow>
                                                        <TableCell className="api-key-header">
                                                            Key
                                                        </TableCell>
                                                        <TableCell className="api-key-value">
                                                            {getAPIKeyToDisplay(userDetails.domainAPIKey)}
                                                            {isCopied ? (
                                                                <div id="SuccessMsg">
                                                                    Key Copied Successfully!
                                                                </div>
                                                            ) : null}
                                                        </TableCell>                                                        
                                                        <TableCell className="api-key-button">
                                                            <Button onClick={handleCopyKey}>
                                                                COPY KEY
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                </Table>
                                            </TableContainer>
                                        </AccordionDetails>
                                    </Accordion>
                                ) : null}
                                </div>
                                {/* <Grid item sm={12} md={12} lg={12} className="OptInControls">
                                    <div>
                                        <FormControlLabel label='Opt-in  to CCPA' control={<Checkbox onChange={handleChange} name="chkbxCCPA" />} />
                                    </div>
                                    <div>
                                        <FormControlLabel label='Opt-in  to receive news/notifications via email' control={<Checkbox onChange={handleChange} name="chkbxNewsNotify" />} />
                                    </div>
                                </Grid> */}
                            </Grid>)}
                        </Grid>
                    </Container>
                </SignInContainer>
            </Grid>
        </Grid>
    );
};

export default AccountDetails;
